import React from 'react';

const labelFn = (labelClass) => {
  const MenuItemLabel = ({ menuItem }) => (
    <span className={labelClass} aria-hidden="true">
      {menuItem.displayText}
    </span>
  );
  return MenuItemLabel;
};

const linkFn = (linkClass) => {
  const MenuItemLink = ({ menuItem }) => {
    const cleanText = menuItem.displayText.replace(/\s+/g, '-').toLowerCase();
    return (
      <a
        href={menuItem.link}
        target={menuItem.external ? '_blank' : '_self'}
        // eslint throws error without this - security risk with target={'_blank'}
        rel="noreferrer"
        data-testid={`menu-item-${cleanText}`}
        className={linkClass}
      >
        {menuItem.displayText}
      </a>
    );
  };
  return MenuItemLink;
};

export function MenuItemFC({
  className,
  labelClassName,
  linkClassName,
  menuItem,
  subMenuContainerClassName,
  subMenuItemClassName,
  subMenuLinkClassName,
}) {
  const ParentTitle = labelFn(labelClassName);
  const Link = linkFn(linkClassName);
  const subMenus = menuItem.subMenu || [];
  const Label = subMenus.length > 0 ? ParentTitle : Link;
  return (
    <div className={className}>
      {/* This will be either a link or the title of a submenu in a span. */}
      <Label menuItem={menuItem} />
      <div className={subMenuContainerClassName}>
        {subMenus.map((subMenuItem) => (
          <MenuItemFC
            key={`submenu-item-key-${subMenuItem.displayText}`}
            className={subMenuItemClassName}
            labelClassName=""
            linkClassName={subMenuLinkClassName}
            menuItem={subMenuItem}
            subMenuContainerClassName=""
            subMenuItemClassName=""
            subMenuLinkClassName=""
          />
        ))}
      </div>
    </div>
  );
}

// Export default for backwards compatibility with imports
export default MenuItemFC;
